'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { SearchBox, useSearchBox } from 'react-instantsearch';
import { debounce } from 'lodash';
import avo from 'analytics/avo';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import useIsBrowser from 'hooks/useIsBrowser';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import isClient from 'commons/isClient';
import IconSearch from 'components/icons/IconSearch';
import IconClose from 'components/icons/iconClose';
import useScreen from 'hooks/useScreen';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from '../../../commons/helpers';
const JBSearchBoxNext = t0 => {
  const $ = _c(77);
  let advanced;
  let forPage;
  let handleSearchBarFocus;
  let index;
  let initialQueryValue;
  let isActive;
  let otherProps;
  let setSearchStateQuery;
  let t1;
  let t2;
  let toggleMobileSearchBar;
  let variant;
  if ($[0] !== t0) {
    const {
      advanced: t3,
      autoFocus,
      defaultRefinement,
      forPage: t4,
      index: t5,
      inMobileNav: t6,
      isActive: t7,
      placeholder: t8,
      setInactive,
      variant: t9,
      initialQueryValue: t10,
      setSearchStateQuery: t11,
      toggleMobileSearchBar: t12,
      handleSearchBarFocus: t13,
      ...t14
    } = t0;
    advanced = t3;
    forPage = t4;
    index = t5;
    t1 = t6;
    isActive = t7;
    t2 = t8;
    variant = t9;
    initialQueryValue = t10;
    setSearchStateQuery = t11;
    toggleMobileSearchBar = t12;
    handleSearchBarFocus = t13;
    otherProps = t14;
    $[0] = t0;
    $[1] = advanced;
    $[2] = forPage;
    $[3] = handleSearchBarFocus;
    $[4] = index;
    $[5] = initialQueryValue;
    $[6] = isActive;
    $[7] = otherProps;
    $[8] = setSearchStateQuery;
    $[9] = t1;
    $[10] = t2;
    $[11] = toggleMobileSearchBar;
    $[12] = variant;
  } else {
    advanced = $[1];
    forPage = $[2];
    handleSearchBarFocus = $[3];
    index = $[4];
    initialQueryValue = $[5];
    isActive = $[6];
    otherProps = $[7];
    setSearchStateQuery = $[8];
    t1 = $[9];
    t2 = $[10];
    toggleMobileSearchBar = $[11];
    variant = $[12];
  }
  const inMobileNav = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "What can we help you find?" : t2;
  const history = useHistory();
  const currentPage = useUserCurrentPageType();
  const [searchQuery, updateSearchQuery] = useState(initialQueryValue || "");
  const {
    query: searchBoxQuery
  } = useSearchBox();
  const {
    isMobile
  } = useScreen();
  const isBrowser = useIsBrowser();
  let t3;
  if ($[13] !== advanced || $[14] !== isBrowser || $[15] !== setSearchStateQuery) {
    t3 = debounce(updatedValue => {
      if ((!isNewConsumerApp && !advanced || isBrowser) && setSearchStateQuery) {
        setSearchStateQuery(updatedValue);
      }
    }, 250);
    $[13] = advanced;
    $[14] = isBrowser;
    $[15] = setSearchStateQuery;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const debouncedSearchStateQueryUpdate = t3;
  let t4;
  if ($[17] !== debouncedSearchStateQueryUpdate) {
    t4 = event => {
      const {
        value
      } = event.target;
      updateSearchQuery(value);
      debouncedSearchStateQueryUpdate(value);
    };
    $[17] = debouncedSearchStateQueryUpdate;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const handleQueryChange = t4;
  let t5;
  if ($[19] !== advanced || $[20] !== currentPage || $[21] !== history || $[22] !== index || $[23] !== isBrowser || $[24] !== otherProps || $[25] !== searchBoxQuery || $[26] !== searchQuery) {
    t5 = () => {
      if (isBrowser) {
        const queryToUse = advanced ? searchQuery : searchBoxQuery;
        avo.productsSearched({
          query: queryToUse,
          location: currentPage,
          searchTarget: avo.SearchTarget.FULL_RESULTS
        });
        const newUrl = getAdvancedSearchUrlForQueryAndIndex(queryToUse, index || ALGOLIA_INDEX_NAME.PRODUCTS, "*");
        history.push(newUrl, {
          instantQuery: queryToUse
        });
        otherProps?.toggleSearchOpen();
      }
    };
    $[19] = advanced;
    $[20] = currentPage;
    $[21] = history;
    $[22] = index;
    $[23] = isBrowser;
    $[24] = otherProps;
    $[25] = searchBoxQuery;
    $[26] = searchQuery;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  const goToAdvancedSearch = t5;
  let t6;
  if ($[28] !== currentPage || $[29] !== forPage || $[30] !== history || $[31] !== index || $[32] !== isMobile || $[33] !== otherProps) {
    t6 = e => {
      if (isMobile) {
        updateSearchQuery(e.currentTarget.value);
        if (otherProps.setSearchEventParams) {
          otherProps.setSearchEventParams({
            searchQuery: e.currentTarget.value,
            currentPage
          });
        }
        return;
      }
      if (forPage !== "associate" && (e.key === "Enter" || e.keyCode === 13) && e.target.value !== "" && isClient()) {
        avo.productsSearched({
          query: e.target.value,
          location: currentPage,
          searchTarget: avo.SearchTarget.FULL_RESULTS
        });
        const newUrl_0 = getAdvancedSearchUrlForQueryAndIndex(e.target.value, index || ALGOLIA_INDEX_NAME.PRODUCTS, "*");
        history.push(newUrl_0, {
          instantQuery: e.target.value
        });
        otherProps?.toggleSearchOpen();
      }
    };
    $[28] = currentPage;
    $[29] = forPage;
    $[30] = history;
    $[31] = index;
    $[32] = isMobile;
    $[33] = otherProps;
    $[34] = t6;
  } else {
    t6 = $[34];
  }
  const handleKeyDown = t6;
  const t7 = variant === "ConsumerInstantSearch";
  let t8;
  if ($[35] !== t7) {
    t8 = classNames("[&_i]:w-[18px] [&_i]:h-[18px] [&_i]:text-[18px] [&_i]:block [&_i]:absolute [&_i]:top-1/2 [&_i]:mt-[-9px] [&_i]:right-10 [&_i]:cursor-pointer [&_i]:[border-right:1px_solid_#dfe0e1] bg-gray-light8", {
      "py-3": t7
    });
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  const t9 = variant !== "ConsumerInstantSearch";
  const t10 = variant === "ConsumerInstantSearch";
  const t11 = variant === "ConsumerInstantSearch" && isActive;
  const t12 = variant === "InstantSearchMobile";
  let t13;
  if ($[37] !== inMobileNav || $[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t9) {
    t13 = classNames("mx-5 my-0 flex flex-row items-stretch relative box-border min-[1440px]:mx-[3.333vw] min-[1440px]:my-0", {
      "px-0 py-[5px]": t9,
      "!ml-3": inMobileNav,
      "px-3 bg-white rounded-[5px] border border-gray-light6 [&_.ais-SearchBox-input]:lg:!pl-0 [&_.ais-SearchBox-input]:lg:!text-left [&_.ais-SearchBox-input]:lg:!indent-[12px] [&_.ais-SearchBox-input::placeholder]:lg:!text-left [&_.ais-SearchBox-input.hasValue]:lg:!indent-[24px]": t10,
      "[&_button.ais-SearchBox-reset]:!block": t11,
      "[&_.ais-SearchBox-input]:indent-[12px]": t12
    });
    $[37] = inMobileNav;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t9;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  const t14 = variant === "InstantSearchMobile";
  let t15;
  if ($[43] !== t14) {
    t15 = classNames("self-center min-w-[16px]", {
      hidden: t14
    });
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== t15) {
    t16 = <IconSearch className={t15} width={18} height={18} />;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== advanced || $[48] !== handleKeyDown || $[49] !== handleQueryChange || $[50] !== placeholder || $[51] !== searchQuery) {
    t17 = advanced && <div className="inline-flex w-full pl-2"><div className="flex w-full"><input className="text-left pl-[30px] [appearance:unset] bg-none [background:none] border-[1px] border-solid border-transparent text-[#333] block [font-size:1rem] font-bold h-10 leading-[1.45rem] tracking-[-.0125rem] w-full" type="search" placeholder={placeholder} autoComplete="off" autoCapitalize="off" spellCheck={false} maxLength={512} value={searchQuery} onChange={handleQueryChange} onKeyDown={handleKeyDown} /></div></div>;
    $[47] = advanced;
    $[48] = handleKeyDown;
    $[49] = handleQueryChange;
    $[50] = placeholder;
    $[51] = searchQuery;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== advanced || $[54] !== handleKeyDown || $[55] !== handleSearchBarFocus || $[56] !== placeholder) {
    t18 = !advanced && <div className="inline-flex w-full" onClick={handleSearchBarFocus} role="button" tabIndex={0}><SearchBox placeholder={placeholder} onKeyDown={handleKeyDown} /></div>;
    $[53] = advanced;
    $[54] = handleKeyDown;
    $[55] = handleSearchBarFocus;
    $[56] = placeholder;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] !== goToAdvancedSearch || $[59] !== isBrowser || $[60] !== toggleMobileSearchBar || $[61] !== variant) {
    t19 = isBrowser && variant === "InstantSearchMobile" && <div className="flex gap-2 items-center"><IconSearch className="self-center min-w-[16px] cursor-pointer" width={18} height={18} onClick={goToAdvancedSearch} /><div className="text-gray">|</div><IconClose className="self-center min-w-[16px] cursor-pointer" width={14} height={14} color="#424242" onClick={toggleMobileSearchBar} /></div>;
    $[58] = goToAdvancedSearch;
    $[59] = isBrowser;
    $[60] = toggleMobileSearchBar;
    $[61] = variant;
    $[62] = t19;
  } else {
    t19 = $[62];
  }
  let t20;
  if ($[63] !== t13 || $[64] !== t16 || $[65] !== t17 || $[66] !== t18 || $[67] !== t19) {
    t20 = <div className={t13}>{t16}{t17}{t18}{t19}</div>;
    $[63] = t13;
    $[64] = t16;
    $[65] = t17;
    $[66] = t18;
    $[67] = t19;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  let t21;
  if ($[69] !== isActive || $[70] !== isMobile || $[71] !== variant) {
    t21 = isMobile && <div className={classNames("h-0 w-0 top-[65px] z-[-1] left-0 fixed bg-white [transition:opacity_.3s_ease-out] opacity-0 lg:absolute lg:bg-transparent", {
      active: isActive,
      hidden: variant === "InstantSearchMobile",
      "lg:opacity-100 lg:h-screen lg:w-screen lg:top-[-100px] lg:absolute lg:[transition:opacity_.3s_ease-out]": isActive
    })} />;
    $[69] = isActive;
    $[70] = isMobile;
    $[71] = variant;
    $[72] = t21;
  } else {
    t21 = $[72];
  }
  let t22;
  if ($[73] !== t20 || $[74] !== t21 || $[75] !== t8) {
    t22 = <div className={t8}>{t20}{t21}</div>;
    $[73] = t20;
    $[74] = t21;
    $[75] = t8;
    $[76] = t22;
  } else {
    t22 = $[76];
  }
  return t22;
};
export default JBSearchBoxNext;